import React from "react";
import { GAevent } from "../../../../utils/googleAnalyticsHelper";
import styles from "./BuyNowButton.module.scss";

const BuyNowButton = ({ product }) => {
  const { Model, BuyNow } = product;

  const handleClick = () => {
    GAevent("Guest-User", "click", `Buy Now Button - ${Model}`);
  };

  return (
    <>
      {BuyNow && (
        <button className={styles.btn}>
          <a className={`BuyNowButton - ${Model}`} href={BuyNow} rel="noreferrer" target="_blank" onClick={handleClick}>
            Buy Now
          </a>
        </button>
      )}
    </>
  );
};

export { BuyNowButton };
